<template>
  <v-card light flat class="text-center align-center">
    <v-card-text v-if="bild.text">
      {{bild.text}}
    </v-card-text>
    <v-img :src="bild.bild" eager/>
  </v-card>
</template>

<script>
  export default {
    name: "AppBarDropdown",
    
    props: {
    bild: Object
    },
  }
</script>